/**
 * Shared FlashList configuration constants.
 */

import { Platform } from 'react-native';

/**
 * Android Fabric: disable the native `removeClippedSubviews` optimization on every
 * FlashList. It detaches off-screen views that FlashList has positioned, and when
 * FlashList recycles them back on-screen Fabric can no longer find their viewState —
 * surfacing as the production fatal `RetryableMountingLayerException: Unable to find
 * viewState for tag N. Surface stopped: false` in SurfaceMountingManager.getViewState.
 * FlashList v2 manages its own recycling, so the native optimization is unnecessary.
 *
 * This mirrors upstream fix Shopify/flash-list#2202 (shipped in 2.3.2); we are pinned
 * at 2.0.2 via Expo SDK 54, so we apply the same `removeClippedSubviews: false` via the
 * `overrideProps` escape hatch instead of bumping the dependency. Spread last onto the
 * underlying ScrollView, so it wins. iOS/web are unaffected (undefined → no override).
 */
export const FLASHLIST_ANDROID_OVERRIDE_PROPS: { removeClippedSubviews: boolean } | undefined =
  Platform.OS === 'android' ? { removeClippedSubviews: false } : undefined;
